export default "__VITE_ASSET__f44135b4__"